export class ConsultaPaginadaViewModel<T> {
	items: T[];
	pageIndex: number;
	pageSize: number;
	totalItems: number;
	totalPages: number;
}